export interface IAumicoStepControl {
    adjustProgressPercentage(): void;
    adjustCompletionState(): void;
}
